import { IConfigComponent } from '@ts/ui-models';
import GlobalDataGrid, { generateConfigComponent } from '@modules/dataGrid/GlobalDataGrid';

export const defaultConfigComponent: IConfigComponent = generateConfigComponent('layer');

interface IEntityProps {
  inheritedProps?: any;
}

const Layers = (props: IEntityProps) => {
  return <GlobalDataGrid configComponent={defaultConfigComponent} inheritedProps={props.inheritedProps} />;
};

export default Layers;
